export const iconFontAwesomeBuildingsHouseCrack = (
	<i className="fa-solid fa-house-crack"></i>
);
